module.exports = __webpack_public_path__ + "img/40800.68884b84.jpg";